import permissions from "app/permissions";
import { EmployeeServicePath, STAFF_REQUEST } from "utils/constants";
import ListStaffRequests from "./List";
import PendingIcon from "@mui/icons-material/Pending";
import PendingRequestsTitle from "../components/PendingRequestsTitle";

const title = "Чакащи заявки";

export const resources = {
  isMenu: true,
  icon: <PendingIcon />,
  name: EmployeeServicePath + STAFF_REQUEST,
  title,
  menuLabel: <PendingRequestsTitle label={title} />, // JSX — shown as the menu label
  list: <ListStaffRequests />,
  permission: permissions.canPreviewStaffRequests,
};
